import { DateValue } from '@mantine/dates';
import moment from 'moment-timezone';

export function getReportTimezone(search: string): string {
    const timezone = new URLSearchParams(search).get('timezone');
    return timezone && moment.tz.zone(timezone) ? timezone : moment.tz.guess(true);
}

export const getReportExclusiveEnd = (search: string): boolean =>
    new URLSearchParams(search).get('exclusiveEnd') === 'true';

export function getInitialReportRange(search: string, allowAllDates = false): [DateValue, DateValue] {
    const params = new URLSearchParams(search);
    if (allowAllDates && params.get('allDates') === 'true') return [null, null];
    const fromDate = params.get('fromDate');
    const toDate = params.get('toDate');
    if (fromDate && toDate &&
        moment(fromDate, moment.ISO_8601, true).isValid() &&
        moment(toDate, moment.ISO_8601, true).isValid()) {
        const timezone = getReportTimezone(search);
        const calendarDate = (value: string, isEnd = false) => {
            const local = moment.tz(value, timezone);
            if (isEnd && getReportExclusiveEnd(search)) local.subtract(1, 'millisecond');
            return new Date(local.year(), local.month(), local.date());
        };
        return [calendarDate(fromDate), calendarDate(toDate, true)];
    }
    return [moment().startOf('month').toDate(), moment().endOf('month').toDate()];
}

export function getRangeDate(
    dateRangePicker: [DateValue, DateValue],
    type?: 'day' | 'month'
): { fromDate: string; toDate: string };
export function getRangeDate(
    dateRangePicker: [DateValue, DateValue],
    type: 'day' | 'month',
    timezone: string,
    exclusiveEnd?: boolean
): { fromDate: string | undefined; toDate: string | undefined };
export function getRangeDate(
    dateRangePicker: [DateValue, DateValue],
    type: 'day' | 'month' = 'day',
    timezone?: string,
    exclusiveEnd = false
) {
    const boundary = (value: DateValue, end: boolean) => {
        if (!value) return timezone ? undefined : moment(value).toISOString();
        const date = timezone
            ? moment.tz(moment(value).format('YYYY-MM-DD'), 'YYYY-MM-DD', timezone)
            : moment(value);
        if (end && exclusiveEnd) return date.add(1, type).startOf(type).toISOString();
        return (end ? date.endOf(type) : date.startOf(type)).toISOString();
    };
    return {
        fromDate: boundary(dateRangePicker[0], false),
        toDate: boundary(dateRangePicker[1], true)
    };
}
